import { QueryClient } from '@tanstack/react-query';

export function createApplicationQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        gcTime: Infinity,
      },
    },
  });
}

export const queryClient = createApplicationQueryClient();
